import * as React from "react";
import { RouteComponentProps, Route, withRouter } from "react-router";
import { WithToast, AudioVideoDefaultProps, BPMCrate, DynamicPlaylist, AddToHistory, FullPlaybackMediaInfo, PlaybackManager, BPMCategory, CrateListView, withToast, Loader, errorToString, resolveCurrentUrl, DropDown, BPMAlbum } from 'bpm-web-generic';
import { downloadMedia } from "src/layout/Main";
import { PagingInfoResponse } from "bpm-client-api";
import { apiCrateToBPMCrate } from "src/transformer";
import { downloadOrCrateMessageHandler } from '../manager/errormessagehandler'
import { mediaAPI } from "src/api/config";
export interface DownloadHistoryProps {
    page: string;
}
interface DownloadHistoryState {
    mode: 'all' | 'audio',
    downloading: boolean,
    clearing: boolean,
    loadingNext: boolean
    albums?: BPMAlbum[],
    pagingInfo?: PagingInfoResponse
    category?: BPMCategory
}
const PAGING_LIMIT = 40;
class DownloadHistoryView extends React.Component<DownloadHistoryProps & RouteComponentProps & WithToast & AudioVideoDefaultProps, DownloadHistoryState> {

    constructor(props: DownloadHistoryProps & RouteComponentProps & WithToast & AudioVideoDefaultProps) {
        super(props);
        this.state = {
            mode: 'all',
            downloading: false,
            clearing: false,
            loadingNext: false
        }
    }

    componentDidMount() {
        this.loadAlbums()
    }

    componentDidUpdate(props: any, state: DownloadHistoryState) {
        if (state.category != this.state.category) {
            this.loadAlbums()
        } else if (state.mode != this.state.mode) {
            this.setState({ category: undefined }, () => this.loadAlbums())
        }
    }

    private playCategory(crate: BPMCrate, slug?: string) {
        let internallist = new DynamicPlaylist([], {
            history_mode: AddToHistory.ALL
        }, 'crate', false)
        internallist.replace(crate.filter(item => {
            if (this.state.mode != 'all' && 'audio' != this.state.mode) {
                return false
            }
            if (!slug) {
                return true
            }
            return item.category.slug == slug
        }).map(album => {
            return {
                album,
                track: album.media[0],
                playbackInfo: album.media[0].stream_info,
                playlist: internallist
            } as FullPlaybackMediaInfo
        }))
        if (internallist.tracks().length > 0) {
            PlaybackManager.getInstance().getContentManager().replaceLists(internallist)
            PlaybackManager.getInstance().startTrack(internallist.tracks()[0])
        }
    }

    private loadAlbums(page: 'next' | 'first' = 'first') {
        if (page == 'first') {
            this.setState({ albums: undefined })
        } else {
            this.setState({ loadingNext: true })
        }
        let skip = 0;
        if (this.state.pagingInfo && page != 'first') {
            skip = this.state.pagingInfo.page * PAGING_LIMIT
        }
        this.apiFunc({ limit: PAGING_LIMIT, skip }).then(({ data: albums, pagination }) => {
            if (page == 'next') {
                albums = (this.state.albums || []).concat(albums)
            }
            this.setState({ albums: albums, pagingInfo: pagination, loadingNext: false })
        }).catch(err => {
            errorToString(err).forEach(error => this.props.showToast('danger', error, () => this.loadAlbums(page)))
        })
    }

    private apiFunc(paging: { limit: number, skip: number }) {
        return mediaAPI.getDownloadHistory(paging.limit, paging.skip, undefined, this.state.category?.slug, `music`).then((data) => {
            return {
                ...data,
                data: apiCrateToBPMCrate(data.data)
            }
        })
    }

    public render() {
        return <div className="download-history">
            <h2 style={{ marginBottom: '40px' }}>Your Download History</h2>
            <div className='filter-section'>
                <span style={{ width: '100%' }}>
                    <div className="av-selector">
                        <DropDown dataSource={(this.state.albums || []).reduce((prev, current) => {
                            if (!prev.find(t => t.id == current.category.id)) {
                                prev.push(current.category)
                            }
                            return prev;
                        }, new Array<BPMCategory>())} keyExtractor={t => t.id.toString()} valueExtractor={(t) => t.name} selected={this.state.category} selectText={'Select a category'} onValueSelected={(value) => {
                            this.setState({ category: value })
                        }} />
                    </div>
                </span>
            </div>
            {!this.state.albums && <Loader />}
            {this.state.albums && <div><CrateListView {...this.props} hideDelete albums={this.state.albums} context={'download_history'} onMediaSelected={this.props.onMediaSelected} onAddToCrate={this.props.onAddToCrate}
                onRemoveFromCrate={this.props.onRemoveFromCrate}
                onAlbumSelected={this.props.onAlbumSelected} onArtistClick={(artist) => {
                    this.props.history.push(`/artist/audio/${encodeURIComponent(artist)}`)
                }} onMediaDownlod={(media, _a, config) => {
                    this.setState({ downloading: true })
                    return downloadMedia(media, false).catch(err => {
                        downloadOrCrateMessageHandler(err, config, this)
                        return false
                    }).finally(() => {
                        this.setState({ downloading: false })
                    })
                }} onEndReached={() => {
                    if (this.state.albums!.length < this.state.pagingInfo!.total && !this.state.loadingNext) {
                        this.loadAlbums('next')
                    }
                }} />
                {this.state.loadingNext && <Loader />}
            </div>}
        </div>
    }
}
const CSD = withToast(DownloadHistoryView)
export default withRouter(class CrateViewRouted extends React.Component<DownloadHistoryProps & RouteComponentProps<{ page: string }>> {
    public render() {
        return <Route path={resolveCurrentUrl(this.props.match.url, ':category?')} render={(p) => {
            return <CSD {...this.props} {...p} page={this.props.match.params.page} />
        }} />
    }
})


// WEBPACK FOOTER //
// ./src/pages/DownloadHistory.tsx